import Vue from 'vue'
import Router from 'vue-router'
// @ 绝对路径 检索到 .....src/
// 如果我们Router当做局部模块使用 一定要Vue.use(Router)
// 以后在组件中  可以通过this.$router  获取Router实例化对象
// 路由信息对象 this.$routes
import Home from '@/components/Home/Home'
import Course from '@/components/Course/Course'
import CourseDetail from '@/components/Course/CourseDetail'
import Login from '@/components/Login/Login'
import Cart from '@/components/Cart/Cart'
import CourseBuy from '@/components/Cart/CourseBuy'
import CourseItem  from '@/components/Course/CourseItem'
import LuffyHeader from '@/components/Common/LuffyHeader'
import UserCenter from '@/components/Common/UserCenter'
import MyInfo from '@/components/USer/MyInfo'
import PracticeList from '@/components/User/PracticeList'
import Practices from '@/components/User/Practices'
import ChangePassword from '@/components/User/ChangePassword'
import PracticeDetail from '@/components/User/PracticeDetail'
import examination from '@/components/assessment/examination'
import mytask from '@/components/assessment/mytask'
import examarrangement from '@/components/assessment/examarrangement'
import taskdetails from '@/components/assessment/taskdetails'
import messcenter from '@/components/assessment/messcenter'
import loadingpage from '@/components/assessment/loadingpage'
import test from '@/components/assessment/test'
import theoryexam from '@/components/assessment/theoryexam'
import theorylist from '@/components/assessment/theorylist'
import answerlist from '@/components/assessment/answerlist'
import index from '@/components/Home/index'
import taskUpload from '@/components/Mobile/taskUpload'
Vue.use(Router)

// 配置路由规则
export default new Router({
   linkActiveClass:'is-active',
  mode: 'hash',
  routes: [
    {
      path: '/',
      component:LuffyHeader,
      redirect:'/course',
      children:[
        {
          path:"/home",
          name:'Home',
          component:Home,
          meta:{
            keepAlive:false,
          }
        },
        {
          path:"/index",
          name:'index',
          component:index,
          meta:{
            keepAlive:false,
          }
        },

        {
          path:"/course",
          name:'Course',
          component:Course,
          meta:{
            keepAlive:true,
          }
        },
        // 课程详情
        {
          path:"/courses/:detailId",
          name:'courseDetail',
          component:CourseDetail,
          meta:{
            keepAlive:false,
          },
          children:[
            {
              path:'details-introduce',
              component:CourseItem,
              meta:{
                keepAlive:false,
              },
            }
          ]
        },
        //用户中心
        {
          path:'ucenter',
          name:'ucenter',
          component:UserCenter,
          meta:{requireAuth:true, keepAlive:false},
          children:[
            {
              path:'myInfo',
              name:'myInfo',
              component: MyInfo,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'practiceList',
              name:'practiceList',
              component: PracticeList,
              meta:{
                keepAlive:true,
              },
            },
            {
              path:'practices',
              name:'practices',
              component: Practices,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'practiceDetail',
              name:'practiceDetail',
              component: PracticeDetail,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'changePassword',
              name:'changePassword',
              component: ChangePassword,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'examination',
              name:'examination',
              component: examination,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'mytask',
              name:'mytask',
              component: mytask,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'examarrangement',
              name:'examarrangement',
              component: examarrangement,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'taskdetails',
              name:'taskdetails',
              component: taskdetails,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'messcenter',
              name:'messcenter',
              component: messcenter,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'theoryexam',
              name:'theoryexam',
              component: theoryexam,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'theorylist',
              name:'theorylist',
              component: theorylist,
              meta:{
                keepAlive:false,
              },
            },
            {
              path:'answerlist',
              name:'answerlist',
              component: answerlist,
              meta:{
                keepAlive:false,
              },
            },

          ]
        },
      ]
    },
    {
      path:"/taskUpload",
      name:'taskUpload',
      component:taskUpload,
      meta:{
        keepAlive:false,
      }
    },
    {
      path:'/login',
      name:'Login',
      component:Login,
      meta:{
        keepAlive:false,
      },
    },
    {
      path:'/loadingpage',
      name:'loadingpage',
      component: loadingpage,
      meta:{
        keepAlive:false,
      },
    },
    {
      path:'/test',
      name:'test',
      component: test,
      meta:{
        keepAlive:false,
      },
    },

    // 购物车的页面
    {
      path:"/purchase/shopping_cart",
      name:'purchase.shop',
      component:Cart,
      meta:{
        keepAlive:false,
      },
    },
    {
      path:'/course/buy',
      name:'course.buy',
      component:CourseBuy,
      meta:{
        keepAlive:false,
      },
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js